import { DigitalSecurityDashboardData } from "../slice/types";

export function hasActiveDigitalSecurityDashboardPayload(
  data: DigitalSecurityDashboardData | null | undefined
): boolean {
  if (!data || typeof data !== "object") return false;

  const msg = String(data.message ?? "").toLowerCase();
  if (msg.includes("no active digital security")) return false;

  const name = data.planName;
  const hasName = typeof name === "string" && name.trim().length > 0;

  const amt = data.amount;
  const hasAmount =
    amt != null &&
    String(amt).trim() !== "" &&
    String(amt).toLowerCase() !== "null";

  return hasName || hasAmount;
}

export function hasSecurityPlanLineContent(
  securityPlan:
    | {
        securityPlanName?: string | null;
        header?: string | null;
        features?: string[] | null;
      }
    | null
    | undefined
): boolean {
  if (!securityPlan) return false;
  const n = securityPlan.securityPlanName;
  if (typeof n === "string" && n.trim().length > 0) return true;
  if (Array.isArray(securityPlan.features) && securityPlan.features.length > 0)
    return true;
  const h = securityPlan.header;
  if (typeof h === "string" && h.trim().length > 0) return true;
  return false;
}

export function isDigitalSecurityTrialPlan(
  data:
    | Pick<
        DigitalSecurityDashboardData,
        "isTrial" | "status" | "subscriptionStatus"
      >
    | { isTrial?: boolean; status?: string | null }
    | null
    | undefined,
  profileHasTrial = false,
): boolean {
  if (profileHasTrial) return true;
  if (!data || typeof data !== "object") return false;
  if (data.isTrial === true) return true;
  const status = String(
    (data as DigitalSecurityDashboardData).status ??
      (data as DigitalSecurityDashboardData).subscriptionStatus ??
      "",
  )
    .trim()
    .toLowerCase();
  return status === "trialing" || status === "trial";
}

export function isDigitalSecurityAccountActiveStatus(
  status: string | null | undefined,
): boolean {
  const normalized = String(status ?? "")
    .trim()
    .toLowerCase();
  return (
    normalized === "active" ||
    normalized === "trialing" ||
    normalized === "trial"
  );
}
